import * as React from "react";
const UploadIcon = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_44098_54196)">
      <path
        d="M4.24707 19.4922H20.2471V12.4922H22.2471V20.4922C22.2471 20.7574 22.1417 21.0118 21.9542 21.1993C21.7666 21.3868 21.5123 21.4922 21.2471 21.4922H3.24707C2.98185 21.4922 2.7275 21.3868 2.53996 21.1993C2.35243 21.0118 2.24707 20.7574 2.24707 20.4922V12.4922H4.24707V19.4922ZM13.2471 9.49219V16.4922H11.2471V9.49219H6.24707L12.2471 3.49219L18.2471 9.49219H13.2471Z"
        fill="#475569"
      />
    </g>
    <defs>
      <clipPath id="clip0_44098_54196">
        <rect
          width={24}
          height={24}
          fill="white"
          transform="translate(0.24707 0.492188)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default UploadIcon;
